import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import NewPasswordLayout from "auth/components/new-password-layout";
import { apiFetch } from "apiFetch";
import { toast } from "react-toastify";
import {emailSignIn} from "../../actions/auth";

class NewPassword extends Component {
  state = {
    redirect: false
  };

  passwordsDontMatch = form => {
    const password = form.password.value;
    const confirmation = form.password_confirmation.value;

    return password !== confirmation;
  };

  passwordsTooShort = password => {
    return password.value.length < 8;
  };

  requestParams = (formFields) => {
    const params = new FormData(formFields);

    params.append("id", this.props.computedMatch.params.id);
    params.append("token", this.props.computedMatch.params.token);

    return params;
  };

  handleSubmit = event => {
    event.preventDefault();

    const dontMatchMessage = "Password and Confirmation should be the same";
    const tooShortMessage = "Password should have at least 8 characters";
    const errorMessage = "An error occured, please try again later";

    const formFields = event.target;

    if (this.passwordsDontMatch(formFields)) {
      toast.error(dontMatchMessage);
      return;
    }

    if (this.passwordsTooShort(formFields.password)) {
      toast.error(tooShortMessage);
      return;
    }

    let body = this.requestParams(formFields, this.props);

    apiFetch("/api/oauth2/user/password", { method: "POST", body})
      .then((response) => {
          this.props.dispatch(emailSignIn({
              email: response.data.email,
              password: body.get("password")
          }));
      })
      .catch(error => {
        if (error && error['error'] && error['error'].endsWith("token not found.")) {
          toast.error(
            "Your Password reset request has expired, please make a new request.",
            { autoClose: 7000 }
          );
          return this.setState({
            redirect: true,
            redirectTo: "/forgot-password"
          });
        }
        toast.error(errorMessage);
      });
  };

  handleCancel = () => {
    this.setState({
      redirect: true,
      redirectTo: "/home"
    });
  };

  render() {
    return this.state.redirect ? (
      <Redirect to={this.state.redirectTo} />
    ) : (
      <NewPasswordLayout
        handleCancel={this.handleCancel}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default NewPassword;



// WEBPACK FOOTER //
// ./src/auth/containers/new-password.js